<template>
	<div class="col-lg-12">
		<div class="activity-list ">
			<div class="activity-item text-block">
				<div>
					<div class="col-lg-8">
						<input v-model="search">
					</div> 
					<div  class="col-lg-4">
						<button @click="getData" class="btn btn-default conversion__form-btn">
							Применить
						</button>
					</div>
				</div>
				<PagesApp :links="links" class="pages col-lg-12" :click="getPage" :select="selectPage" />
				<LoaderItem v-show="rolesGetting" />
				<table class="table table-striped" v-show="!rolesGetting">
					<tr>
						<th v-for="field in fields" :key="field.key">{{ field.name }}</th>
					</tr>
					<tr v-for="item in data" :key="item.id">
						<td v-for="field in fields" 
						:key="field.key">
							<div v-if="field.key === 'isRegistrar'">
								<button v-if="item.isRegistrar" class="btn btn-default conversion__form-btn delete" @click="() => deleteRole(item.id)">
									Лишить роли
								</button>
								<button v-else class="btn btn-default conversion__form-btn add" @click="() => addRole(item.id)">
									Дать роль
								</button>
							</div> 
							<div v-else>
								{{ item[field.key] }}
							</div>
						</td>
					</tr>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { getDataWithToken } from '@/api/getData'
import { postWithToken } from '@/api/saveData'
import { deleteWithToken } from '@/api/deleteData'
import { getConfig } from '@/auth';
import PagesApp from '@/components/PagesApp.vue'
import LoaderItem from '@/components/LoaderItem'

export default {
	components: {
		PagesApp, LoaderItem
	},
	data() {
		return {
			data: [],
			fields: [
				{ "name": "ФИО", "key": "fullname" }, 
				{ "name": "Имя пользователя", "key": "username" }, 
				{ "name": "Организация", "key": "organization_name" }, 
				{ "name": "Ведомство", "key": "department" }, 
				{ "name": "Подведомство", "key": "subdepartment" }, 
				{ "name": "Должность", "key": "position" }, 
				{ "name": "Регистратор", "key": "isRegistrar" }, 
			],
			count: 0,
			max: 30,
			links: [],
			error: '',
			selectPage: 0,
			search: '',
			rolesGetting: false
		}
	},
	created() {
		this.getData()
	},
	methods: {
		getData: function() {
			const urlCount = getConfig().authServer.baseUrl +  getConfig().authServer.usersCount
			const url = getConfig().authServer.baseUrl +  getConfig().authServer.users
			const max = this.max

			this.getCounts(urlCount).then(() => {
				const selectPage = this.selectPage
				this.getPage(`${url}?max=${max}&first=${max * selectPage}`, selectPage)
			})
		},
		getPage: function (url, index) {
			let search = this.search !== '' ? `&search=${this.search}` : '' 
		
			this.selectPage = index
			//getDataWithToken('https://reception.gorodperm.ru/auth/admin/realms/reception/clients/17e306b4-7c2a-43e5-b4ca-99e983ebcded/roles').then(x => console.log(x))
			getDataWithToken('https://reception.gorodperm.ru/auth/admin/realms/reception/clients?clientId=frontend').then(x => console.log(x))
			
			this.rolesGetting = true	
			getDataWithToken(`${url}${search}`)
				.then(async users => {
					console.log(users)
					let data = users.map(el => {
						let attributes = el.attributes ?? {}
						el.fullname = `${el.lastName ?? ''} ${el.firstName ?? ''} ${attributes.middleName ?? ''}`
						el.organization_name = attributes?.organization_name?.[0] ?? ''
						el.department = attributes?.department?.[0] ?? ''
						el.subdepartment = attributes?.subdepartment?.[0] ?? ''
						el.position = attributes?.position?.[0] ?? ''

						return el 
					})
					
					await this.getRoles(users)

					this.data = data
				})
				.catch(error => {
					this.error = error + ''
				})
		},
		getRoles: async function(users) {
			let url = getConfig().authServer.baseUrl +  getConfig().authServer.users

			await Promise.all(users.map(async el => {
				await getDataWithToken(url + `/${el.id}/role-mappings`)
					.then(roles => {
						el.roles = roles.realmMappings
						el.isRegistrar = roles.realmMappings.find(role => role.name === 'registrar') ? true : false
					})
			})).then((() => {
				this.rolesGetting = false
			} ))
		},
		getCounts: async function (urlCount) {
			let url = getConfig().authServer.baseUrl +  getConfig().authServer.users 
			let search = this.search !== '' ? `&search=${this.search}` : '' 
			let max = this.max

			await getDataWithToken(`${urlCount}?t=1${search}`).then(count => {
				this.count = count
				if (this.selectPage >= Math.ceil(count / max)) {
					this.selectPage = 0
				}

				this.links = new Array(Math.ceil(count / max))
					.fill(0)
					.map((x, i) => ({
						url: `${url}?max=${max}&first=${i*max}${search}`,
						label: i + 1
					}))
			})
		},
		addRole: function(id) {
			let url = getConfig().authServer.baseUrl + getConfig().authServer.addRole.replace('${userId}', id)
			let roles = [getConfig().authServer.registrarRole]
			
			postWithToken(url, 
				JSON.stringify(roles), 
				{'Content-Type': 'application/json'}
			).then(() => {
				this.getData()
			})
		},
		deleteRole: function(id) {
			let url = getConfig().authServer.baseUrl + getConfig().authServer.deleteRole.replace('${userId}', id)
			let roles = [getConfig().authServer.registrarRole]

			deleteWithToken(url,
				JSON.stringify(roles), 
				{'Content-Type': 'application/json'}
			).then(() => {
				this.getData()
			})
		}
	}
}
</script>